export const aspect = {
  VEHICLE_STATE: 'unitState',
  VEHICLE_STATE_HISTORY: 'stateHistory',
  FIELDS_OPERATION_HISTORY: 'fieldOperationHistory',
  FIELDS_OPERATION_HISTORY2: 'fieldOperationHistory2',
  WEATHER_METADATA_ASPECT: 'WeatherMetadataAspect',
  THERMOROD_MEASUREMENTS: 'thermorodMeasurements',
};
